import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.css'
})
export class ButtonComponent {
  @Input() color: string = '#ededed';
  @Input() textColor: string = '#000000';

  @Input() minWidth: string = '0px'; // Como maximo se puede poner 90px

  @Input() text: string = '';
  @Input() icon: string = '';

  @Output() clickB = new EventEmitter;

  eventClick(){
    this.clickB.emit();
  }
}
